"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var dialog_1 = require("@reach/dialog");
var react_1 = __importStar(require("react"));
var react_spring_1 = require("react-spring");
var shortid_1 = __importDefault(require("shortid"));
var context_1 = require("../../context");
var __1 = require("../../");
require("./Dialog.scss");
var useDialog_1 = __importDefault(require("./hooks/useDialog"));
exports.useDialog = useDialog_1.default;
var DiaglogActionType;
(function (DiaglogActionType) {
    DiaglogActionType["SUCCESS"] = "success";
    DiaglogActionType["DANGER"] = "danger";
})(DiaglogActionType = exports.DiaglogActionType || (exports.DiaglogActionType = {}));
var AnimatedDialogOverlay = react_spring_1.animated(dialog_1.DialogOverlay);
var AnimatedDialogContent = react_spring_1.animated(dialog_1.DialogContent);
var Dialog = function (props) {
    var trans = context_1.useSemantics().trans;
    var _a = props.actionType, actionType = _a === void 0 ? DiaglogActionType.SUCCESS : _a, _b = props.confirmLabel, confirmLabel = _b === void 0 ? trans('optiiva::labels.confirm') : _b, _c = props.cancelLabel, cancelLabel = _c === void 0 ? trans('optiiva::labels.cancel') : _c, dusk = props.dusk, _d = props.heading, heading = _d === void 0 ? trans('optiiva::labels.are-you-sure') : _d, show = props.show, text = props.text, onConfirm = props.onConfirm, _e = props.onCancel, onCancel = _e === void 0 ? null : _e;
    var transitions = react_spring_1.useTransition(show, null, {
        from: { opacity: 0, transform: 'translateY(-20px)' },
        enter: { opacity: 1, transform: 'translateY(0)' },
        leave: { opacity: 0, transform: 'translateY(120px)' },
    });
    var labelId = react_1.useMemo(function () { return "label--" + shortid_1.default(); }, []);
    var confirm = function (e) {
        e.preventDefault();
        onConfirm();
    };
    function closeDialog(e) {
        e.preventDefault();
        onCancel && onCancel();
    }
    return (react_1.default.createElement(react_1.default.Fragment, null, transitions.map(function (_a) {
        var item = _a.item, key = _a.key, styles = _a.props;
        return item && (react_1.default.createElement(AnimatedDialogOverlay, { key: key, style: { opacity: styles.opacity } },
            react_1.default.createElement("div", { className: "fixed z-10 inset-0 overflow-y-auto" },
                react_1.default.createElement("div", { className: "flex items-end justify-center min-h-screen pt-12 px-4 pb-12 text-center sm:block sm:px-0" },
                    react_1.default.createElement("div", { className: "fixed inset-0 transition-opacity" },
                        react_1.default.createElement("div", { className: "absolute inset-0 bg-gray-500" })),
                    react_1.default.createElement("span", { "data-dusk": "dialog-center-space", className: "hidden sm:inline-block sm:align-middle sm:h-screen" }),
                    "\u200B",
                    react_1.default.createElement(AnimatedDialogContent, { "data-dusk": dusk, "aria-labelledby": labelId, style: { transform: styles.transform }, className: "inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full" },
                        react_1.default.createElement("div", { className: "p-8" },
                            heading && (react_1.default.createElement("div", { className: "font-medium text-xl mb-2" }, heading)),
                            react_1.default.createElement("div", null, text)),
                        react_1.default.createElement("div", { className: "bg-gray-light py-4 px-8 sm:flex sm:flex-row-reverse sm:justify-between" },
                            react_1.default.createElement("span", { className: "flex w-full sm:mt-0 sm:w-auto" },
                                actionType === DiaglogActionType.SUCCESS && (react_1.default.createElement(__1.Button, { className: "w-full", onClick: confirm }, confirmLabel)),
                                actionType === DiaglogActionType.DANGER && (react_1.default.createElement(__1.DangerButton, { className: "w-full", onClick: confirm }, confirmLabel))),
                            react_1.default.createElement("span", { className: "mt-3 flex w-full sm:mt-0 sm:w-auto sm:mr-6" },
                                react_1.default.createElement(__1.WhiteButton, { className: "w-full", onClick: closeDialog }, cancelLabel))))))));
    })));
};
exports.default = Dialog;
//# sourceMappingURL=index.js.map